import { api } from './client';
import type {
  AnalysisView,
  AnalysisViewCreate,
  AnalysisViewUpdate,
  AnalysisViewListResponse,
} from '@/types/analysisView';

export const analysisViewsApi = {
  async list(tankId: string): Promise<AnalysisViewListResponse> {
    return api.get(`/api/tanks/${tankId}/analysis/views`);
  },

  async create(tankId: string, data: AnalysisViewCreate): Promise<AnalysisView> {
    return api.post(`/api/tanks/${tankId}/analysis/views`, data);
  },

  async update(
    tankId: string,
    viewId: string,
    data: AnalysisViewUpdate
  ): Promise<AnalysisView> {
    return api.patch(`/api/tanks/${tankId}/analysis/views/${viewId}`, data);
  },

  async remove(tankId: string, viewId: string): Promise<void> {
    return api.delete(`/api/tanks/${tankId}/analysis/views/${viewId}`);
  },
};
